module.exports = __webpack_public_path__ + "static/2019426:2ace0725733a716000c6/img/theTrip_3x.42853c5.png";


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/home/theTrip_3x.png
// module id = PyRu
// module chunks = 41